$(function () {
  var officeTourSelector = '.office-tour.fragment';

  if ($(officeTourSelector).length) {
    var officeTour = new OfficeTour(officeTourSelector);
    officeTour.enable();
  }
});
